<template>
  <div class="pad-occupancy"
    :set-adults="adults = info.occupancy.adults"
    :set-children="children = info.occupancy.children.length"
    >
    <span>{{ nights }} {{ nights !== 1 ? 'notti' : 'notte' }}</span>
    <span>
      {{ adults }} {{ adults !== 1 ? 'adulti' : 'adulto' }}
      <span v-if="children">&nbsp;e {{ children }} {{ children !== 1 ? 'bambini' : 'bambino' }}</span>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { deep_clone } from "@src/utilities"

export default {
  name: 'pad-occupancy',

  components: {
  },

  props: {
    nights: Number,
  },

  data() {
    return {
      info: {
        nights: this.nights,
        occupancy: null,
      }
    }
  },

  computed: {
    ...mapState({
      // stato globale
      occupancy: state => state.occupancy,
    }),
  },

  created() {
    this.info.occupancy = deep_clone(this.occupancy)[0]
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .pad-occupancy {
    font-size: $font-size-sm;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: $grid-gutter-width / 6;

    span {
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width / 5;

      &:after {
        content: '';
        width: 4px;
        height: 4px;
        display: inline-block;
        border-radius: $border-radius;
        background-color: $gray-600;
        margin-left: $grid-gutter-width / 5;
      }

      &:last-child {
        margin-right: 0;

        &:after {
          display: none;
        }
      }
    }
  }

</style>